var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { customElement, PICAction, PIC, PICBase, fetchApiData, stringDecoder, exportFetchURL, exportFetchHeaders, PICText, booleanDecoder, numberDecoder, } from '../Internals';
let PICOpenAPIDocs = class PICOpenAPIDocs extends PICBase {
    static get styles() {
        const defaultStyle = css `
      .pic-container {
        display: flex;
        flex-direction: column;
        margin: 12px 12px 12px 0px;
        border-top: 1px solid black;
      }

      .pic-containerheader {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
      }

      .pic-containerheadercollapsable {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
      }

      .pic-containerheadercollapsable:hover {
        cursor: pointer;
      }

      .pic-containerheaderLeft {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #000000;
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }

      .pic-containerheaderRight,
      .pic-containeHeaderRightLabel {
        font-size: 20px;
        line-height: 20px;
        color: var(--pic-onSurfaceHighColor);
      }

      .pic-containeHeaderRightLabel {
        font-family: 'Material Design Icons';
      }

      .pic-containeHeaderRightLabel.mdi-chevron-up::before {
        font-family: 'Material Design Icons';
        content: '\u{F0143}';
        height: 20px;
        width: 20px;
      }

      .pic-containeHeaderRightLabel.mdi-chevron-down::before {
        font-family: 'Material Design Icons';
        content: '\u{F0140}';
        height: 20px;
        width: 20px;
      }

      .pic-containerheaderRightCol {
        display: flex;
        flex-direction: column;
      }

      .pic-containeHeaderRightCheckBox {
        position: absolute;
        opacity: 0;
        z-index: -1;
      }

      .pic-containerbody {
        background-color: white;
        display: flex;
        /* flex-flow: wrap; */
        flex-direction: column;
      }

      .pic-containerbodyhidden {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 300ms ease, opacity 800ms ease;
      }

      .pic-containerbodyvisible {
        transition: max-height 300ms ease, opacity 800ms ease;
        opacity: 1;
        /* max-height: 100vh; */
        display: flex;
      }

      .pic-containerfooter {
        background-color: cyan;
      }

      .httpMethod {
        margin-top: 2px;
        width: 5rem;
        text-align: center;
        border-radius: 5px;
        color: white;
        text-transform: uppercase;
      }

      .httpMethod.post {
          background-color: var(--pic-statusOkColor);
        }
        
      .httpMethod.put {
          background-color: var(--pic-statusWarningColor);
      }
        
      .httpMethod.get {
          background-color: var(--pic-statusInfoColor);
      }

      .httpMethod.delete {
        background-color: var(--pic-statusErrorColor);
      }

      .endpointHdr {
        display: flex;
        text-transform: capitalize;
      }

      .endpointHdr > .pic-h4 {
        font-weight: bold;
      }

      .apiPath {
        text-transform: none;
        font-weight: bold;
      }

      .apiDesc {
        font-size: small;
      }

      .sectionOuterContainer {
        /* border: 1px solid black; */
        padding: 0rem 1rem;
      }

      .sectionContainerHdr {
        border-bottom: 1px solid black;
        padding: 0px 0rem 0rem 1rem;
        display: flex;
        justify-content: space-between;
      }
      
      .paramTable {
        width: 100%;
      }

      .paramTable td,
      .paramTable th {
        text-align: left;
        padding: 0px 10px;
      }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    constructor() {
        super();
        this.path = '';
        this.useOpenAPI = true;
        this.useEditor = false;
        this.responsesLimit = 1;
        this.specificationUrl = 'scripts/picit/CargoNet_Demo.json';
        this.paths = new Map();
        this.idCnt = 1;
    }
    connectedCallback() {
        super.connectedCallback();
        this.getDataFromAPI();
    }
    flattenOpenAPI() {
        var _a, _b;
        if (this.apiDocument && this.apiDocument.paths)
            for (let endpointName in this.apiDocument.paths) {
                let path = this.apiDocument.paths[endpointName];
                let urlParameters = undefined;
                for (let methodName in path) {
                    if (methodName.toLowerCase() == 'parameters') {
                        urlParameters = path[methodName];
                        continue;
                    }
                    else if (methodName.toLowerCase() == '$ref')
                        continue;
                    let curMethod = path[methodName];
                    if (urlParameters) {
                        if (curMethod.parameters)
                            curMethod.parameters.push(urlParameters);
                        else
                            curMethod.parameters = urlParameters;
                    }
                    let mappedPath = { endpointName: endpointName, methodName: methodName, method: curMethod };
                    if (curMethod.tags) {
                        for (let curTag of curMethod.tags) {
                            if (this.paths.has(curTag)) {
                                (_a = this.paths.get(curTag)) === null || _a === void 0 ? void 0 : _a.push(mappedPath);
                            }
                            else {
                                this.paths.set(curTag, [mappedPath]);
                            }
                        }
                    }
                    else {
                        if (this.paths.has(endpointName)) {
                            (_b = this.paths.get(endpointName)) === null || _b === void 0 ? void 0 : _b.push(mappedPath);
                        }
                        else {
                            this.paths.set(endpointName, [mappedPath]);
                        }
                    }
                }
            }
    }
    sysIdToURLFront() {
        if (PIC.systemId.includes('udv') || PIC.systemId.includes('sfltest') || PIC.systemId.includes('gtstest'))
            return 'udv';
        else if (PIC.systemId.match(/rnd\d+_test/))
            return 'rndweb';
        else if (PIC.systemId.includes('_test'))
            return 'demo';
        else
            return 'udv';
    }
    getDataUrl(iRelativeUrl) {
        return this.doURI(this.sysIdToURLFront(), iRelativeUrl);
    }
    getDataFromAPI() {
        let url = this.getDataUrl(this.specificationUrl);
        fetch(url).then(res => res.json()).then(data => {
            this.apiDocument = data;
            this.flattenOpenAPI();
            this.requestUpdate();
        });
    }
    doURI(front, back) {
        let arr = location.hostname.split('.');
        arr[0] = front;
        return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
    }
    //TODO: fix url when you figure out where this is supposed to be used
    exportFetchCMD(options) {
        return `fetch("${this.doURI('rndapi', 'v1/cargonet/v1/booking')}", {
            "headers": {  },
            "referrer": "${this.doURI('rndweb')}",
            "referrerPolicy": "strict-origin-when-cross-origin",
            "body": "{}",
            "method": "POST",
            "mode": "cors",
            "credentials": "include"
          });`;
    }
    exportcURLCMD(iHM, options) {
        return `curl ${exportFetchHeaders().map(x => `-H '${x[0]}: ${x[1]}'`).join(' ')} -X ${iHM === null || iHM === void 0 ? void 0 : iHM.id.toUpperCase()} ${this.getURL(iHM, options)}`;
    }
    //TODO: make this use API key if available
    getOptions(postMethod, url, postBody) {
        let options;
        if (postMethod !== 'GET' && postBody) {
            options = {
                systemId: null,
                method: postMethod,
                postBody: postBody,
                path: url,
                formatOutput: 'raw',
                errorReturn: true,
                url: url,
            };
        }
        else {
            options = {
                systemId: null,
                method: postMethod,
                path: url,
                formatOutput: 'raw',
                errorReturn: true,
                url: url
            };
        }
        return options;
    }
    getURL(iHM, options) {
        var _a;
        let firstPart = exportFetchURL(options);
        let secondPart = iHM ? (_a = iHM.queryParam) === null || _a === void 0 ? void 0 : _a.map(qp => qp.value ? `${qp.key}=${qp.value}&` : ``).join('') : undefined;
        return secondPart ? `${firstPart}?${secondPart.slice(0, -1)}` : firstPart;
    }
    renderContainerResponse(containerId, endpointName, methodName, method) {
        var _a, _b, _c;
        let returnTemplate = html ``;
        if ((_a = method.render) === null || _a === void 0 ? void 0 : _a.responses) {
            if (this.useEditor)
                returnTemplate = html `
        <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Responses</div>
            <table class="paramTable">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                ${(_b = method.render) === null || _b === void 0 ? void 0 : _b.responses.map((r) => html `<tr>
                    <td>${r.statusCode}</td>
                    <td>
                    <pic-editor 
                        .id=${'txtab'}
                        .editorHeight=${`${this.getNumRowsTextArea(r.value) * 1.2}rem`}
                        .editorWidth=${'99%'}
                        .editorData=${r.value} 
                        .editorLanguage=${'json'}>
                    </pic-editor>
                    </td>
                  </tr> `)}
              </tbody>
            </table>
          </div>
        </section>
      `;
            else
                returnTemplate = html `
      <section>
        <div class="sectionOuterContainer">
          <div class="sectionContainerHdr pic-h6">Responses</div>
          <table class="paramTable">
            <thead>
              <tr>
                <th>Code</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              ${(_c = method.render) === null || _c === void 0 ? void 0 : _c.responses.map((r) => html `<tr>
                  <td>${r.statusCode}</td>
                  <td>
                    <pic-textarea
                      .density=${'high'}
                      .id=${'txtab'}
                      .label=${'Response'}
                      .value=${r.value}
                      .eType=${'default'}
                      .rows=${this.getNumRowsTextArea(r.value)}
                      .width=${this.getWidthTextArea(r.value)}
                    ></pic-textarea>
                  </td>
                </tr> `)}
            </tbody>
          </table>
        </div>
      </section>
    `;
        }
        return returnTemplate;
    }
    /* Open api*/
    getNumRowsTextArea(iTxt) {
        let numRows = 1;
        if (iTxt) {
            try {
                numRows = iTxt.split(/\r\n|\r|\n/).length;
                numRows = numRows > 30 ? 30 : numRows;
            }
            catch (_a) {
                numRows = 1;
            }
        }
        return numRows;
    }
    getWidthTextArea(iTxt) {
        if (this.getNumRowsTextArea(iTxt) === 1) {
            if (iTxt.length) {
                // if (iTxt.length * 0.576 === NaN)
                //     return '15rem'
                // else 
                if (iTxt.length * 0.576 > 50)
                    return '50rem';
                else
                    return String(iTxt.length * 0.576) + 'rem';
            }
            else
                return '15rem';
        }
        else
            return '50rem';
    }
    getFetchURL(containerId, endpointName, methodName, method) {
        // return exportFetchURL({path: `${this.getPathURL(containerId, endpointName, methodName, method).substring(1)}`, systemId: PIC.systemId, isRestV1: true});
        return `${this.getServerURL()}${this.getPathURL(containerId, endpointName, methodName, method)}`;
    }
    getQueryParameters(containerId, method, isURLParam) {
        var _a;
        let parmMap = (_a = method.parameters) === null || _a === void 0 ? void 0 : _a.map(p => { return Object.assign(Object.assign({}, p), { domId: `fld_${containerId}_${method.operationId}_${p.name}`.replace(/\//g, '_') }); }).map(parameters => {
            var _a;
            let inputFld = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${parameters.domId}`);
            let val = '';
            if (inputFld && inputFld instanceof PICText) {
                val = inputFld.submitValue;
            }
            if (isURLParam && parameters.name == isURLParam) {
                isURLParam = val;
                return;
            }
            else if (parameters.required || val) {
                return `${parameters.name}=${val}`;
            }
        });
        let returnStr = '';
        if (parmMap) {
            let parmStr = parmMap.filter(x => x != undefined).join('&');
            if (isURLParam)
                returnStr += isURLParam;
            if (parmStr)
                returnStr += `?${parmStr}`;
        }
        return returnStr;
    }
    getPathURL(containerId, endpointName, methodName, method) {
        let pathURL = endpointName;
        let matchArr = pathURL.match(/({).*?(})/g);
        let matchArrInner = pathURL.match(/(?<={).*?(?=})/g);
        if (matchArr && matchArrInner) {
            let matchStr = matchArr[0];
            let paramValue = this.getQueryParameters(containerId, method, matchArrInner[0]);
            pathURL = pathURL.replace(matchStr, paramValue);
        }
        else {
            pathURL += this.getQueryParameters(containerId, method);
        }
        return pathURL;
    }
    //TODO: make this a dropdown, but default should always be your current system
    //TODO: make this capable of testing against current system, so you dont run production things from udv
    getServerURL() {
        let serverURLStr = '';
        if (this.apiDocument) {
            this.apiDocument.servers.map(server => {
                var _a;
                serverURLStr = server.url;
                (_a = server.url.match(/({).*?(})/g)) === null || _a === void 0 ? void 0 : _a.forEach(variable => {
                    let JSvariable = variable;
                    JSvariable = JSvariable.replace(/{|}/g, '');
                    if (server.variables && server.variables[JSvariable]) {
                        let defaultVar = server.variables[JSvariable].default;
                        serverURLStr = serverURLStr.replace(variable, defaultVar);
                    }
                });
            });
        }
        return serverURLStr;
    }
    getFetchCMD(containerId, endpointName, methodName, method) {
        var _a;
        let postBody = '';
        let curBodyTxtArea = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#txtBody_${containerId}`);
        if (curBodyTxtArea) {
            let textAreaData;
            if (this.useEditor)
                textAreaData = curBodyTxtArea.editorData;
            else
                textAreaData = curBodyTxtArea.submitValue;
            if (textAreaData) {
                try {
                    postBody = JSON.stringify(JSON.parse(textAreaData));
                }
                catch (_b) {
                    console.log('invalid JSON');
                }
            }
        }
        let URLwithParams = this.getFetchURL(containerId, endpointName, methodName, method);
        // let options = this.getOptions(methodName as APIMethod, URLwithParams, postBody);
        let returnStr = `fetch("${URLwithParams}", {
            "headers": { ${exportFetchHeaders().map(x => `'${x[0]}':'${x[1]}'`).join(',')} },
            "method": "${methodName.toUpperCase()}"${postBody.length > 0 ? `,\r\n"body": "${postBody}",` : ''}
          });`;
        return returnStr;
    }
    getcURLCMD(containerId, endpointName, methodName, method) {
        return `curl \r\n${exportFetchHeaders().map(x => `-H '${x[0]}: ${x[1]}'`).join('\r\n')}\r\n-X ${methodName.toUpperCase()} ${this.getFetchURL(containerId, endpointName, methodName, method)}`;
    }
    updateRequestCMDs(containerId, endpointName, methodName, method) {
        var _a, _b;
        let cURLId = `#cURL_${containerId}_${method.operationId}`.replace(/\//g, '_');
        let fetchId = `#fetch_${containerId}_${method.operationId}`.replace(/\//g, '_');
        let cURLStr = this.getcURLCMD(containerId, endpointName, methodName, method);
        let fetchStr = this.getFetchCMD(containerId, endpointName, methodName, method);
        let cURLElm = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(cURLId);
        let fetchElm = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(fetchId);
        if (cURLElm)
            cURLElm.value = cURLStr;
        if (fetchElm)
            fetchElm.value = fetchStr;
    }
    onClickContainer(contId) {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${contId} .pic-containerbody`)) === null || _b === void 0 ? void 0 : _b.classList.toggle('pic-containerbodyhidden');
        (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector(`#${contId} .pic-containerbody`)) === null || _d === void 0 ? void 0 : _d.classList.toggle('pic-containerbodyvisible');
        let isVisible = (_e = this.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector(`#${contId} .pic-containerbody.pic-containerbodyvisible`);
        let curIcon = (_f = this.shadowRoot) === null || _f === void 0 ? void 0 : _f.querySelector(`#${contId} .pic-containeHeaderRightLabel`);
        curIcon === null || curIcon === void 0 ? void 0 : curIcon.classList.toggle('mdi-chevron-down');
        curIcon === null || curIcon === void 0 ? void 0 : curIcon.classList.toggle('mdi-chevron-up');
    }
    onClickTryIt(containerId, endpointName, methodName, method) {
        var _a;
        let postBody = undefined;
        let curBodyTxtArea = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#txtBody_${containerId}`);
        if (curBodyTxtArea) {
            let textAreaData;
            if (this.useEditor)
                textAreaData = curBodyTxtArea.editorData;
            else
                textAreaData = curBodyTxtArea.submitValue;
            if (textAreaData) {
                try {
                    postBody = JSON.parse(textAreaData);
                }
                catch (_b) {
                    console.log('invalid JSON');
                }
            }
        }
        let URLwithParams = this.getFetchURL(containerId, endpointName, methodName, method);
        let options = this.getOptions(methodName.toUpperCase(), URLwithParams, postBody);
        fetchApiData('', options)
            .then(async (result) => {
            let val = await result.text();
            try {
                let jsonVal = JSON.parse(val);
                val = JSON.stringify(jsonVal, null, 2);
            }
            catch (_a) { }
            return { statusCode: result.status, value: val };
        }).then(data => {
            if (method.render) {
                if (method.render.responses)
                    method.render.responses.push(data);
                else
                    method.render = { responses: [data] };
            }
            else {
                method.render = { responses: [data] };
            }
            this.requestUpdate();
        }).catch((err) => {
            console.log('Onlick try it falid', err);
            let data = { statusCode: '500', value: err };
            if (method.render) {
                if (method.render.responses)
                    method.render.responses.push(data);
                else
                    method.render = { responses: [data] };
            }
            else {
                method.render = { responses: [data] };
            }
            this.requestUpdate();
        });
    }
    schemaObjectToJSON(schemaName, schema) {
        var _a;
        let outerObj = {};
        let innerObj = {};
        for (let prop in schema.properties) {
            if (schema.properties[prop].type) {
                let type = schema.properties[prop].type;
                if (type === 'number' || type === 'integer')
                    innerObj[prop] = 0;
                else
                    innerObj[prop] = "";
            }
            else
                innerObj[prop] = "";
        }
        outerObj[schemaName] = innerObj;
        return (_a = JSON.stringify(outerObj, null, 2)) !== null && _a !== void 0 ? _a : '';
    }
    schemaToJSON(schemaName, schema) {
        switch (schema.type) {
            case 'object':
                return this.schemaObjectToJSON(schemaName, schema);
            case 'list':
                return '';
            case 'array':
                return `[${this.schemaObjectToJSON(schemaName, schema)}]`;
            default:
                return '';
        }
    }
    getRequestBody(method) {
        var _a;
        let returnStr = '';
        let refStr = (_a = method.requestBody.content['application/json']) === null || _a === void 0 ? void 0 : _a.schema.$ref;
        if (refStr) {
            let accessArr = refStr.split('/');
            if (accessArr && accessArr.length > 2) {
                let curPropName = accessArr[1];
                let curObj = this.apiDocument[curPropName];
                for (let i = 2; i < accessArr.length; i++) {
                    curPropName = accessArr[i];
                    curObj = curObj[curPropName];
                }
                returnStr = this.schemaToJSON(curPropName, curObj);
            }
        }
        return returnStr;
    }
    renderInputField(iId, containerId, endpointName, methodName, method, iLbl) {
        let onChangeAction = new PICAction('internal', this.updateRequestCMDs.bind(this, containerId, endpointName, methodName, method));
        onChangeAction.trigger_ = 'change';
        return html `
      <pic-text
        .id_=${iId}
        .label=${iLbl !== null && iLbl !== void 0 ? iLbl : ''}
        .eType=${'default'}
        .density=${'inline'}
        .selfAction=${new PICAction('internal', this.onClickTryIt.bind(this, containerId, endpointName, methodName, method))}
        .actionElements=${new Map().set('change', onChangeAction)}
      ></pic-text>
    `;
    }
    renderContainerExamples(containerId, endpointName, methodName, method) {
        let returnTemplate = html ``;
        let cURLStr = this.getcURLCMD(containerId, endpointName, methodName, method);
        let fetchStr = this.getFetchCMD(containerId, endpointName, methodName, method);
        if (this.useEditor != this.useEditor)
            returnTemplate = html `
        <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Exampels</div>
                <pic-editor 
                    .id=${"editorExampels"}
                    .editorHeight=${`${this.getNumRowsTextArea(cURLStr) * 1.2}rem`}
                    .editorWidth=${'99%'}
                    .editorData=${cURLStr} 
                    .editorLanguage=${'json'}
                    .enableMinimap=${false}
                    >
                </pic-editor>
          </div>
        </section>
      `;
        else
            returnTemplate = html `
      <section>
          <div class="sectionOuterContainer">
            <div class="sectionContainerHdr pic-h6">Exampels</div>
                <pic-textarea
                    .density=${'high'}
                    .id=${`cURL_${containerId}_${method.operationId}`.replace(/\//g, '_')}
                    .label=${'cURL'}
                    .value=${cURLStr}
                    .eType=${'default'}
                    .rows=${this.getNumRowsTextArea(cURLStr)}
                    .width=${this.getWidthTextArea(cURLStr)}
                ></pic-textarea>
                <pic-textarea
                    .density=${'high'}
                    .id=${`fetch_${containerId}_${method.operationId}`.replace(/\//g, '_')}
                    .label=${'fetch'}
                    .value=${fetchStr}
                    .eType=${'default'}
                    .rows=${this.getNumRowsTextArea(fetchStr)}
                    .width=${this.getWidthTextArea(fetchStr)}
                ></pic-textarea>
          </div>
        </section>
        `;
        return returnTemplate;
    }
    renderContainerBody(containerId, endpointName, methodName, method) {
        let returnTemplate = html ``;
        if (method.requestBody) {
            let paresedRequestBody = this.getRequestBody(method);
            if (this.useEditor)
                returnTemplate = html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr pic-h6">Body</div>
                <pic-editor 
                    .id=${`txtBody_${containerId}`}
                    .editorHeight=${`${this.getNumRowsTextArea(paresedRequestBody) * 1.2}rem`}
                    .editorWidth=${'99%'}
                    .editorData=${paresedRequestBody} 
                    .editorLanguage=${'json'}>
                </pic-editor>
            </div>
        </section>
        `;
            else
                returnTemplate = html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr pic-h6">Body</div>
                <pic-textarea
                    .density=${'high'}
                    .id=${`txtBody_${containerId}`}
                    .label=${'Body'}
                    .value=${paresedRequestBody}
                    .eType=${'default'}
                    .rows=${this.getNumRowsTextArea(paresedRequestBody)}
                    .width=${this.getWidthTextArea(paresedRequestBody)}
                ></pic-textarea>
            </div>
        </section>
        `;
        }
        return returnTemplate;
    }
    renderContainerParams(containerId, endpointName, methodName, method) {
        var _a;
        if (method.parameters && method.parameters.length > 0)
            return html `
      <section>
        <div class="sectionOuterContainer">
          <div class="">${method.description}</div>
          <div class="sectionContainerHdr pic-h6">
            Query Parameters
            <pic-button
              .action=${new PICAction('internal', this.onClickTryIt.bind(this, containerId, endpointName, methodName, method))}
              .width=${'10rem'}
              .eType=${'outlined'}
              .density=${'medium'}
              .label=${'Try it'}
            ></pic-button>
          </div>
          <table class="paramTable">
            <thead>
              <tr>
                <th>Key</th>
                <th>Type</th>
                <th>Value</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              ${(_a = method.parameters) === null || _a === void 0 ? void 0 : _a.map((p) => {
                var _a;
                return html `<tr>
                  <td>${p.name}</td>
                  <td>${(_a = p.schema) === null || _a === void 0 ? void 0 : _a.type}</td>
                  <td>
                    ${this.renderInputField(`fld_${containerId}_${method.operationId}_${p.name}`.replace(/\//g, '_'), containerId, endpointName, methodName, method, '')}
                  </td>
                  <td>${p.description}</td>
                </tr> `;
            })}
            </tbody>
          </table>
        </div>
      </section>
    `;
        else
            return html `
        <section>
            <div class="sectionOuterContainer">
                <div class="sectionContainerHdr">
                    <div class="">${method.description}</div>
                    <pic-button
                    .action=${new PICAction('internal', this.onClickTryIt.bind(this, containerId, endpointName, methodName, method))}
                    .width=${'10rem'}
                    .eType=${'outlined'}
                    .density=${'medium'}
                    .label=${'Try it'}
                    ></pic-button>
                </div>
            </div>
        </section>
          `;
    }
    //TODO: render what respones the api can have from documentation
    renderContainerInnerHTML(containerId, endpointName, methodName, method) {
        return html `
      ${this.renderContainerParams(containerId, endpointName, methodName, method)}
      ${this.renderContainerBody(containerId, endpointName, methodName, method)}
      ${this.renderContainerExamples(containerId, endpointName, methodName, method)}
      ${this.renderContainerResponse(containerId, endpointName, methodName, method)}
      `;
    }
    rendercontainer(contId, contMethod, contPath, contDesc, innerHTML) {
        return html `
      <div id=${contId} class="pic-container">
        <div
          class="pic-containerheadercollapsable"
          @click=${() => this.onClickContainer(contId)}
        >
          <div class="pic-containerheaderLeft">
            <div class="httpMethod ${contMethod} pic-h6">${contMethod}</div>
            <div class="apiPath pic-button">${contPath}</div>
            <div class="apiDesc pic-body1">${contDesc}</div>
          </div>
          <div class="pic-containerheaderRight">
            <input
              id="pic-containeHeaderRightCheckBox-${contId}"
              type="checkbox"
              @click=${() => this.onClickContainer(contId)}
              class="pic-containeHeaderRightCheckBox"
            /><label
              id="pic-containeHeaderRightLabel-${contId}"
              for="pic-containeHeaderRightCheckBox-${contId}"
              class="pic-containeHeaderRightLabel mdi-chevron-down"
            ></label>
          </div>
        </div>
        <div class="pic-containerbody pic-containerbodyhidden pic-body2">
          ${innerHTML}
        </div>
        <div class="pic-containerfooter"></div>
      </div>
    `;
    }
    renderMethod(endpointName, methodName, method) {
        let containerId = `${endpointName}_${methodName}`.replace(new RegExp('\/|\{|\}', 'gm'), '_') + ++this.idCnt;
        return html `
        ${this.rendercontainer(containerId, methodName, endpointName, method.description, this.renderContainerInnerHTML(containerId, endpointName, methodName, method))}
        `;
    }
    renderPaths() {
        var _a;
        let paths = [];
        (_a = this.paths) === null || _a === void 0 ? void 0 : _a.forEach((tag, tagName) => {
            paths.push(html `
                            <div class="endpointHdr">
                                <div class="pic-h4">${tagName ? tagName : 'Orphans'}</div>
                                <div class="pic-h6">${""}</div>
                            </div>
                            `);
            for (let endpoint of tag) {
                paths.push(this.renderMethod(endpoint.endpointName, endpoint.methodName, endpoint.method));
            }
        });
        return paths;
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            ${this.renderPaths()}
             `;
    }
};
__decorate([
    property({ converter: stringDecoder })
], PICOpenAPIDocs.prototype, "path", void 0);
__decorate([
    property({ converter: booleanDecoder })
], PICOpenAPIDocs.prototype, "useOpenAPI", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'useeditor' })
], PICOpenAPIDocs.prototype, "useEditor", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'responseslimit' })
], PICOpenAPIDocs.prototype, "responsesLimit", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICOpenAPIDocs.prototype, "specificationUrl", void 0);
PICOpenAPIDocs = __decorate([
    customElement('pic-openapidocs')
], PICOpenAPIDocs);
export { PICOpenAPIDocs };
//# sourceMappingURL=PICOpenAPIDocs.js.map